import { Button, Stack } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import { APIS } from 'src/lib/constants/apis';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { BICValidation, IBANValidation, Required } from 'src/lib/validation/ValidationTypes';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import Schema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const VNDefaultProjektDaten: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const handleBankDatenUebernehmen = () => {
		let appCopy = cloneDeep(application);

		set(
			appCopy,
			P.Bankverbindung_Bank.path,
			get(application, P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Bankverbindung_Geldinstitut.path, '')
		);
		set(
			appCopy,
			P.Bankverbindung_IBAN.path,
			get(application, P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Bankverbindung_IBAN.path, '')
		);
		set(
			appCopy,
			P.Bankverbindung_BIC.path,
			get(application, P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Bankverbindung_BIC.path, '')
		);

		setApplicationProperty('attributes', get(appCopy, 'attributes'));
	};

	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />

			<Stack spacing={2} sx={{ mb: '1rem' }}>
				<MUIAlert
					title={'Hinweis:'}
					message={
						'Bitte überprüfen Sie diese von Ihnen im Antrag angegebenen Daten. Sollten sich zwischenzeitlich Änderungen ergeben haben, nehmen Sie diese bitte im Profil vor und aktualisieren dann hier Ihre Angaben.'
					}
				/>
				<Button onClick={handleBankDatenUebernehmen} disabled={readOnly}>
					Daten aktualisieren
				</Button>
			</Stack>

			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStruc()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={true}
						api={APIS.Antrag}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStruc2()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={true}
						api={APIS.Antrag}
					/>
				</Grid2>
			</Grid2>

			<CreateForm
				formStruc={formStrucBankdaten(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={true}
			/>
		</>
	);
};
export default VNDefaultProjektDaten;

const formStruc = () => {
	return [
		{
			fields: [
				{ ...P.Foerderantrag.schema.attributes.Allgemein_Projekttitel, tooltip: null, disabled: true },
				{ ...P.Foerderantrag.schema.attributes.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation, tooltip: '', disabled: true },
				{ ...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Strasse_Und_Hausnummer, tooltip: '', disabled: true },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
const formStruc2 = () => {
	return [
		{
			fields: [
				{ ...P.Foerderantrag.schema.attributes.Allgemein_Geplante_Projektlaufzeit_von, tooltip: '', disabled: true },
				{ ...P.Foerderantrag.schema.attributes.Allgemein_Geplante_Projektlaufzeit_bis, tooltip: '', disabled: true },
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [{ ...P.Allgemein_Haushaltsjahr, disabled: true, required: false, label: 'Haushaltsjahr' }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_PLZ, tooltip: '', disabled: true },
				{ ...P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Ort, tooltip: '', disabled: true },
			],
			userProps: { columnToDivide: 2 },
		},
	];
};

const formStrucBankdaten = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Bankverbindung_Bank,
				{ ...P.Bankverbindung_IBAN, validation: [{ validateFunction: Required }, { validateFunction: IBANValidation }] },
			],
			// userProps: { direction: 'column', columnToDivide: 2 },
		},
		{
			fields: [{ ...P.Bankverbindung_BIC, validation: [{ validateFunction: Required }, { validateFunction: BICValidation }] }],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];

	const iban = get(application, P.Bankverbindung_IBAN.path, '');
	if (typeof iban === 'string' && iban.includes('DE')) {
		struc.pop();
	}

	return struc;
};
export const getFormStrucVNDefaultProjektDaten = (application: any): FormStrucItem[] => {
	return concat(formStrucBankdaten(application));
};
